var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeAccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36113_668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3055 2.22217C8.28331 2.22217 6.61108 2.64995 6.61108 3.38883V10.3888C6.61108 11.0888 8.28331 11.5555 10.3055 11.5555C12.3278 11.5555 14 11.0888 14 10.3888V3.42772C14 2.68883 12.3278 2.22217 10.3055 2.22217Z",
    fill: "#FF80AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.91671V6.88893C12.9889 7.62782 11.0444 7.66671 10.3055 7.66671C9.56664 7.66671 7.69997 7.58893 6.61108 7.0056V5.91671C6.61108 6.46115 8.28331 6.88893 10.3055 6.88893C12.3278 6.88893 14 6.46115 14 5.91671ZM10.3055 4.5556C8.28331 4.5556 6.61108 4.12782 6.61108 3.58337V4.67226C7.69997 5.2556 9.56664 5.33337 10.3055 5.33337C11.0444 5.33337 12.9889 5.29448 14 4.5556V3.58337C14 4.12782 12.3278 4.5556 10.3055 4.5556ZM10.3055 9.22226C8.28331 9.22226 6.61108 8.79448 6.61108 8.25004V9.33893C7.69997 9.92226 9.56664 10 10.3055 10C11.0444 10 12.95 9.92226 14 9.22226V8.25004C14 8.79448 12.3278 9.22226 10.3055 9.22226Z",
    fill: "#EC407A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 13.5L0 11.9444V1.05556L8.16667 -0.5V13.5Z",
    fill: "#C51162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43344 3.58337C4.00566 3.62226 3.57789 3.66115 3.15011 3.66115C2.60566 5.6056 2.06122 7.55004 1.55566 9.49449C1.90566 9.53337 2.25566 9.53337 2.60566 9.57226C2.72233 9.14448 2.839 8.71671 2.91678 8.25004C3.46122 8.28893 4.04455 8.28893 4.589 8.28893C4.70566 8.7556 4.82233 9.22226 4.939 9.68893C5.36678 9.72782 5.75566 9.76671 6.18344 9.8056C5.639 7.74448 5.05566 5.64449 4.43344 3.58337ZM3.189 7.27782C3.38344 6.42226 3.65566 5.56671 3.77233 4.67226C3.92789 5.56671 4.20011 6.38337 4.39455 7.27782C3.96677 7.27782 3.57789 7.27782 3.189 7.27782Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36113_668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAccessIcon);
export default __webpack_public_path__ + "static/media/OfficeAccessIcon.11f7fba4afa56547b18457aa0a910a31.svg";
export { ForwardRef as ReactComponent };